import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('../views/Home.vue')
	},
	{
		path: '/course:courseId',
		name: 'CourseIndex',
		component: () => import('../views/course/Index.vue'),
		children: [
			{
				path: 'ch:chapterId(\\d+)?/module:moduleId(\\d+)?/:type?:typeId(\\d+)?',
				name: 'Course',
				component: () => import('../views/course/Course.vue')
			},
			{
				path: 'chapters',
				name: 'CourseChapters',
				component: () => import('../views/course/Chapters.vue')
			},
			{
				path: 'statistics',
				name: 'Statistics',
				component: () => import('../views/course/Statistics.vue')
			}
		]
	},
	{
		path: '/course:courseId/module:moduleId/:type?:typeId',
		name: 'Course-old',
		redirect: { path: '/course:courseId/ch0/module:moduleId/:type:typeId'}
	},
	{
		path: '/page/:pageUrl',
		name: 'Page',
		component: () => import('../views/Page.vue')
	},
	{
		path: '/support',
		name: 'Support',
		component: () => import('../views/Support.vue')
	},
	{
		path: '/profile',
		name: 'Profile',
		component: () => import('../views/profile/Index.vue')
	},
	{
		path: '/profile/receipts',
		name: 'ProfileReceipts',
		component: () => import('../views/profile/Receipts.vue')
	},
	{
		path: '/404',
		name: '404',
		component: () => import('../views/404.vue')
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: {name: '404'}
	}
]

const router = createRouter({
	history: createWebHistory('/lk'),
	routes: routes,
	scrollBehavior(to, from, savedPosition): any {
		const pos = savedPosition || {x: 0, y: 0}
		if (to.name !== from.name) {
			return new Promise(resolve => {
				setTimeout(() => {
					resolve(pos)
				}, 200)
			})
		}
		return pos
	}
})

export default router

